$( document ).ready(function() {
  document.getElementById("modal-events-container").style.height = "0%";
  // document.getElementById("modal-events-container").style.position = "absolute";
  // document.getElementById("modal-events-container").style.top = "300px";
});

$('.modal-events-open').click(function(){
  document.getElementById("modal-events-container").style.height = "100%";
  $('html, body').css({ overflow: 'hidden', height: '100%' });
})

$('.modal-events-close').click(function(){
  document.getElementById("modal-events-container").style.height = "0%";
  $('html, body').css({ overflow: 'auto', height: 'auto' });
})

// close modal overlay with esc key
$(document).keyup(function(e) {
  if (e.which == 27) {
    document.getElementById("modal-events-container").style.height = "0%";
    $('html, body').css({ overflow: 'auto', height: 'auto' });
  }
});



// WEBPACK FOOTER //
// ./assets/js/features/modalEvents.js